import { TranslatedBenefitRow } from '@fcom/dapi/api/models';
import { LocationRouteType } from '@fcom/core-api';

import { CHANGED_BENEFITS_BY_CLASS, SUPERLIGHT_FARE_FAMILIES, HIGHLIGHTED_SUPERLIGHT_BENEFITS } from './benefit.utils';

/**
 *  This is temporary highlighting
 *
 * @param benefit
 * @param highlightedBenefits
 */
export const getBenefitHighlightingClassObject = (
  benefit: TranslatedBenefitRow,
  highlightedBenefits: string[] = []
): { [key: string]: boolean } => {
  return highlightedBenefits.includes(benefit.key) ? { 'alert-50-bg': true } : {};
};

export const getHighlightedBenefits = (
  cabinClass: string,
  isShortHaul: boolean,
  routeType: LocationRouteType,
  fareFamilyCode?: string
): string[] =>
  SUPERLIGHT_FARE_FAMILIES.includes(fareFamilyCode)
    ? HIGHLIGHTED_SUPERLIGHT_BENEFITS
    : CHANGED_BENEFITS_BY_CLASS[cabinClass]?.[isShortHaul ? 'shortHaul' : 'longHaul'][routeType] || [];
